import { forkJoin, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import {
  ClearInterventionHistoryErrors,
  InterventionHistoryActionToggleLoading,
  InterventionHistoryActionTypes,
  InterventionHistoryPageCancelled,
  InterventionHistoryPageLoaded,
  InterventionHistoryPageRequested,
  InterventionHistoryPageToggleLoading,
  ThrowInterventionHistoryError,
} from '../actions/intervention-history.actions';
import { QueryParamsModel } from '../../../../core/_base/crud';
import { AuthService } from '../../../../core/auth';
import { AppState } from '../../../../core/reducers';
import { MedReviewService } from '../services/med-review.service';

@Injectable()
export class InterventionHistoryEffects {
  showPageLoadingDistpatcher = new InterventionHistoryPageToggleLoading({ isLoading: true });
  showActionLoadingDistpatcher = new InterventionHistoryActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new InterventionHistoryActionToggleLoading({ isLoading: false });

  @Effect()
  loadInterventionHistoryPage$ = this.actions$.pipe(
    ofType<InterventionHistoryPageRequested>(
      InterventionHistoryActionTypes.InterventionHistoryPageRequested,
    ),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.medReviewService.findInterventionHistory(
        payload.page,
        payload.patient_id,
        payload.drp_id,
      );
      const lastQuery = of(payload.page);
      return forkJoin(requestToServer, lastQuery).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new InterventionHistoryPageCancelled();
            } else {
              this.store.dispatch(new ThrowInterventionHistoryError({ error: response[0].error }));
              return new InterventionHistoryPageCancelled();
            }
          } else {
            const result = response[0];
            // tslint:disable-next-line:no-shadowed-variable
            const lastQuery: QueryParamsModel = response[1];
            this.store.dispatch(new ClearInterventionHistoryErrors());
            return new InterventionHistoryPageLoaded({
              interventionHistory: result.data,
              totalCount: result.count,
              page: lastQuery,
            });
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private medReviewService: MedReviewService,
    private authService: AuthService,
    private store: Store<AppState>,
    private router: Router,
  ) {}
}
